module.exports = __webpack_public_path__ + "static/BackgroudImagePortfolio-39ef9e56eaed1e12a8363ade30312a16.svg";